module.exports = __webpack_public_path__ + "static/media/status-dropdown.7ad69ebd.svg";